import { HttpParams, HttpResponse } from '@angular/common/http';

import { QueryConfig } from './query-config.utils';

import { AppColor } from '@models/commons/app-color.model';
import { Color } from '@models/authentication/enums/color.enum';

export class AppUtils {
  static buildPageableParams(config: QueryConfig): HttpParams {
    let params = new HttpParams();

    if (config) {
      params = params.set('page', `${config.pager.page}`);
      params = params.set('pageSize', `${config.pager.pageSize}`);
      if (config.sorter.field) {
        params = params.set('sortBy', `${config.sorter.field}`);
        params = params.set('isSortingAscending', `${config.sorter.isSortingAscending}`);
      }

      config.filters.forEach((filter) => {
        if (filter.value !== 'All' && filter.value !== 'ALL' && filter.value) {
          if (filter.value instanceof Array) {
            filter.value.forEach((value) => {
              params = params.append(filter.field, value);
            });
          } else {
            params = params.append(filter.field, filter.value);
          }
        }
      });
    }
    return params;
  }

  static buildQueryParams(queryParams: []): HttpParams {
    let params = new HttpParams();

    if (queryParams.length > 0) {
      queryParams.forEach((qp: any) => {
        if (qp.value) {
          params = params.append(qp.field, qp.value);
        }
      });
    }

    return params;
  }

  static formatValue(value: number): string {
    return value ? `${value.toLocaleString('ro', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} ron` : '0,00 ron';
  }

  static get appColors(): AppColor[] {
    return Object.values(Color).map(color => this.appColor(color));
  }

  static appColor(color: Color): AppColor {
    switch (color) {
      case Color.RED:
        return new AppColor(color, '#ed1b24', '#fabbbd', '#e0080d');
      case Color.BLUE:
        return new AppColor(color, '#2196f3', '#6ec6ff', '#0069c0');
      case Color.GREEN:
        return new AppColor(color, '#4caf50', '#80e27e', '#087f23');
      case Color.ORANGE:
        return new AppColor(color, '#ff9800', '#ffc947', '#c66900');
      case Color.BROWN:
        return new AppColor(color, '#795548', '#a98274', '#4b2c20');
      case Color.PURPLE:
        return new AppColor(color, '#ab47bc', '#df78ef', '#790e8b');
    }
  }

  static downloadFile(data: HttpResponse<Blob>) {
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(data.body);
    const contentDispositionHeader = data.headers.get('content-disposition');
    const filename = contentDispositionHeader?.split(';')[1].trim().split('=')[1];
    downloadLink.download = filename.replace(/"/g, '');
    downloadLink.click();
  }

  static openFile(data: HttpResponse<Blob>) {
    const contentDispositionHeader = data.headers.get('content-disposition');
    const filename = contentDispositionHeader?.split(';')[1].trim().split('=')[1];
    const fileData = new File([data.body], filename, {type: 'application/pdf'});
    const fileURL = window.URL.createObjectURL(fileData);
    window.open(fileURL, '_blank');
  }

  static isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
}
